import eventEmitter, { AUTH_EVENTS } from "../../util/eventEmitter";
import { userActions } from "../user/user-slice";
import { storeAuthDetails } from "../user/user-actions";

let registered = false;

// Must be called as soon as the store exists. These used to be registered
// lazily from a middleware, which only runs once an action is dispatched -
// bootstrap code in index.js fires API calls (and therefore token refreshes)
// before React mounts and before anything dispatches, so the first
// NEED_AUTH / SESSION_EXPIRED of the session was emitted with no listener
// attached and silently dropped.
export const registerAuthEventListeners = (store) => {
  if (registered) return;
  registered = true;

  eventEmitter.on(AUTH_EVENTS.STORE_AUTH_DETAILS, (details) => {
    store.dispatch(storeAuthDetails(details));
  });

  eventEmitter.on(AUTH_EVENTS.SESSION_EXPIRED, () => {
    store.dispatch(
      userActions.setError("User Session expired please login in again"),
    );
  });

  eventEmitter.on(AUTH_EVENTS.AUTH_ERROR, (error) => {
    store.dispatch(userActions.setError(error));
  });

  eventEmitter.on(AUTH_EVENTS.NEED_AUTH, () => {
    store.dispatch(userActions.sessionExpired());
  });
};
